import { Font } from '@react-pdf/renderer';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import PagePreloader from 'modules/shared/components/loaders/PagePreloader';
import { IllustrationView, StopWatchIllustration } from 'modules/shared/features/illustration';
import { Outlet } from 'react-router-dom';

import poppinsBold from 'assets/fonts/Poppins/Poppins-Bold.ttf';
import poppinsMedium from 'assets/fonts/Poppins/Poppins-Medium.ttf';
import poppinsRegular from 'assets/fonts/Poppins/Poppins-Regular.ttf';
import poppinsSemiBold from 'assets/fonts/Poppins/Poppins-SemiBold.ttf';
import useAppApiUrlData from 'modules/shared/hooks/useAppApiUrlData';
import useBuildVersionUpdater from 'modules/shared/hooks/useBuildVersionUpdater';

dayjs.extend(minMax);

Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: poppinsRegular,
        },
        {
            src: poppinsMedium,
            fontWeight: 'medium',
        },
        {
            src: poppinsSemiBold,
            fontWeight: 'semibold',
        },
        {
            src: poppinsBold,
            fontWeight: 'bold',
        },
    ],
});

ChartJS.register(CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend, LineElement, BarElement);

// const GA_MEASUREMENT_ID = 'G-570WJD13PJ';

const AppLayout = () => {
    useBuildVersionUpdater();

    const appApiUrlData = useAppApiUrlData();

    // const { token } = useAuthSelector();

    // const location = useLocation();

    // useEffect(() => {
    //     if (!token) return;

    //     if (document.getElementById('ga-script')) {
    //         // Script already injected
    //         return;
    //     }

    //     // Load main GA script
    //     const script1 = document.createElement('script');
    //     script1.id = 'ga-script';
    //     script1.async = true;
    //     script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    //     document.head.appendChild(script1);

    //     // Initialize GA
    //     const script2 = document.createElement('script');
    //     script2.innerHTML = `
    //         window.dataLayer = window.dataLayer || [];
    //         function gtag(){ dataLayer.push(arguments); }
    //         gtag('js', new Date());
    //         gtag('config', '${GA_MEASUREMENT_ID}');
    //     `;
    //     document.head.appendChild(script2);
    // }, [token]);

    // useEffect(() => {
    //     if (!token) return;

    //     const w = window as any;
    //     if (typeof w.gtag !== 'function') return;

    //     w.gtag('event', 'page_view', {
    //         page_path: location.pathname + location.search,
    //         page_location: window.location.href,
    //         page_title: document.title,
    //     });
    // }, [location.pathname, location.search, token]);

    if (appApiUrlData.isLoading) return <PagePreloader />;

    if (appApiUrlData.isError)
        return (
            <IllustrationView
                className="mt-[25vh]"
                illustration={<StopWatchIllustration />}
                title="Page Not Found"
                message={
                    <>
                        Sorry but the page you are looking for does not exist, <br /> have been removed or renamed.
                    </>
                }
            />
        );

    return <Outlet />;
};

export default AppLayout;
